/* KrutiKala search overlay — Figma SearchOverlay.tsx */
(function () {
  // v2: the old key could hold the former placeholder terms.
  const STORAGE_KEY = 'kk_recent_searches_v2';

  try {
    localStorage.removeItem('kk_recent_searches');
  } catch (_) {}

  function readRecent() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter((x) => typeof x === 'string' && x.trim()).slice(0, 6) : [];
    } catch (_) {
      return [];
    }
  }

  function writeRecent(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, 6)));
    } catch (_) {}
  }

  function pushRecent(term) {
    const t = (term || '').trim();
    if (!t) return;
    const next = [t, ...readRecent().filter((x) => x.toLowerCase() !== t.toLowerCase())].slice(0, 6);
    writeRecent(next);
  }

  function removeRecent(term) {
    writeRecent(readRecent().filter((x) => x !== term));
  }

  function searchUrl(term) {
    const base = (window.routes && window.routes.search_url) || '/search';
    return `${base}?q=${encodeURIComponent(term)}&options%5Bprefix%5D=last&type=product`;
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function escapeAttr(s) {
    return escapeHtml(s).replace(/'/g, '&#39;');
  }

  function renderRecent(scope) {
    const list = scope.querySelector('[data-kk-recent-list]');
    const wrap = scope.querySelector('[data-kk-recent-wrap]');
    if (!list || !wrap) return;
    const items = readRecent();
    if (!items.length) {
      wrap.hidden = true;
      list.innerHTML = '';
      return;
    }
    wrap.hidden = false;
    list.innerHTML = items
      .map(
        (item) => `
      <li class="kk-search-overlay__recent-item">
        <a class="kk-search-overlay__recent-link" href="${searchUrl(item)}" data-kk-recent-term="${escapeAttr(item)}">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.35-4.35"/></svg>
          ${escapeHtml(item)}
        </a>
        <button type="button" class="kk-search-overlay__recent-remove" data-kk-recent-remove="${escapeAttr(item)}" aria-label="Remove ${escapeAttr(item)}">
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </li>`
      )
      .join('');
  }

  function syncTyping(root, scope, input) {
    const hasQuery = (input.value || '').trim().length > 0;
    root.classList.toggle('is-typing', hasQuery);
    scope.classList.toggle('is-typing', hasQuery);
    scope.querySelector('[data-kk-clear]')?.classList.toggle('is-visible', hasQuery);
    scope.querySelector('[data-kk-submit]')?.classList.toggle('is-visible', hasQuery);
    const results = scope.querySelector('[data-kk-results]');
    if (results) results.hidden = !hasQuery;
    const viewAll = scope.querySelector('[data-kk-view-all]');
    if (viewAll) {
      const q = (input.value || '').trim();
      viewAll.href = searchUrl(q || '');
      const label = scope.querySelector('[data-kk-view-all-label]');
      if (label) label.textContent = q ? `View all results for “${q}”` : 'View all results';
    }
  }

  function init(root) {
    const portal = root.querySelector('[data-kk-search-portal]');
    const panel = root.querySelector('[data-kk-search-panel]');
    const input = root.querySelector('[data-kk-search-input]');
    const form = root.querySelector('[data-kk-search-form]');
    const openBtn = root.querySelector('[data-kk-search-open]');
    if (!portal || !panel || !input || !form || !openBtn) return;

    if (portal.parentElement !== document.body) {
      document.body.appendChild(portal);
    }

    // Mirror typing class on portal so CSS that targets .kk-search-overlay.is-typing
    // still works after portal is moved — scope styles via portal class too.
    portal.classList.add('kk-search-overlay');

    const open = () => {
      portal.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('kk-search-open');
      renderRecent(portal);
      syncTyping(root, portal, input);
      setTimeout(() => input.focus(), 40);
    };

    const close = () => {
      portal.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('kk-search-open');
      root.classList.remove('is-typing');
      portal.classList.remove('is-typing');
      input.value = '';
      syncTyping(root, portal, input);
    };

    root._kkOpenSearch = open;
    root._kkCloseSearch = close;

    openBtn.addEventListener('click', (e) => {
      e.preventDefault();
      open();
    });

    portal.querySelectorAll('[data-kk-search-close]').forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();
        close();
      });
    });

    input.addEventListener('input', () => syncTyping(root, portal, input));

    portal.querySelector('[data-kk-clear]')?.addEventListener('click', () => {
      input.value = '';
      syncTyping(root, portal, input);
      input.focus();
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    form.addEventListener('submit', () => pushRecent(input.value));

    portal.addEventListener('click', (e) => {
      const removeBtn = e.target.closest('[data-kk-recent-remove]');
      if (removeBtn) {
        e.preventDefault();
        e.stopPropagation();
        removeRecent(removeBtn.getAttribute('data-kk-recent-remove'));
        renderRecent(portal);
        return;
      }
      const termLink = e.target.closest('[data-kk-recent-term]');
      if (termLink) pushRecent(termLink.getAttribute('data-kk-recent-term'));
      const chip = e.target.closest('[data-kk-search-chip]');
      if (chip) pushRecent(chip.getAttribute('data-kk-search-chip') || chip.textContent);
    });

    portal.querySelector('[data-kk-view-all]')?.addEventListener('click', () => {
      pushRecent(input.value);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !portal.hidden) close();
    });

    renderRecent(portal);
    syncTyping(root, portal, input);
  }

  const searchPath = (window.routes && window.routes.search_url) || '/search';
  if (window.location.pathname.replace(/\/$/, '').endsWith(searchPath.replace(/\/$/, ''))) {
    const q = new URLSearchParams(window.location.search).get('q');
    if (q) pushRecent(q);
  }

  document.querySelectorAll('[data-kk-search-overlay]').forEach(init);

  document.querySelectorAll('[data-kk-open-search]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const overlay = document.querySelector('[data-kk-search-overlay]');
      if (!overlay) {
        window.location.href = (window.routes && window.routes.search_url) || '/search';
        return;
      }
      const header = document.querySelector('kk-header');
      if (header && typeof header.closeDrawer === 'function') header.closeDrawer();
      if (typeof overlay._kkOpenSearch === 'function') overlay._kkOpenSearch();
    });
  });
})();
